module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjys_rybs@2x.71f1039f.png";